interface KeyboardHandler<T> {

    items?: T[]

    focusedIndex: number
    setFocusedIndex(index: number): void

    select(index: number): void

    close(): void

    /** If true, the focused element will be selected when pressing Tab */
    selectOnTab?: boolean

}

export function useKeyboardHandler<T>(open: boolean, handler: KeyboardHandler<T>) {

    const { items, focusedIndex, setFocusedIndex, close, select, selectOnTab } = handler

    React.useEffect(() => {

        if (open && items) {

            const handleKeyDown = (e: KeyboardEvent) => {

                if (e.code === "Escape") {
                    e.preventDefault()
                    close()
                    return
                }

                if (e.code === "Enter") {
                    e.preventDefault()
                    select(focusedIndex)
                    return
                }

                if ((e.code === "Tab") && selectOnTab) {
                    e.preventDefault()
                    select(focusedIndex)
                    return
                }

                let i = 0
                const length = items.length

                if (e.code === "ArrowUp") {
                    i = - 1
                }
                else if (e.code === "ArrowDown") {
                    i = 1
                }
                else if (e.code === "PageUp") {
                    i = -10
                }
                else if (e.code === "PageDown") {
                    i = 10
                }

                if (i) {

                    e.preventDefault()

                    i += focusedIndex
                    i = (i < 0) ? length - 1 : ((i >= length) ? 0 : i)

                    if (i !== focusedIndex) {
                        setFocusedIndex(i)
                    }

                }

            }

            document.addEventListener("keydown", handleKeyDown)

            return () => document.removeEventListener("keydown", handleKeyDown)

        }


    }, [open, items, focusedIndex, select, close, setFocusedIndex, selectOnTab])

}    
